<div class="card cadastro-evento-container">
    <p-toolbar styleClass="mb-4 cadastro-evento-toolbar">
        <ng-template pTemplate="left">
            <button pButton pRipple label="Novo"
                icon="pi pi-plus" class="p-button-success mr-2" (click)="openNew()"></button>
        </ng-template>
    </p-toolbar>

    <div class="cadastro-evento-table-wrapper" #tableWrapper>
        <p-table #dt [value]="data" [rows]="20" styleClass="p-datatable-gridlines p-datatable-responsive-demo"
            [paginator]="true" [rowHover]="true" dataKey="id"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} registros" [showCurrentPageReport]="true"
            [globalFilterFields]="['id','descricao_evento']"
            [scrollable]="true" [scrollHeight]="scrollHeight">

        <ng-template pTemplate="caption">
            <div class="flex p-flex-column p-flex-md-row align-items-center justify-content-between">
                <h5 class="p-m-0">Cadastro de Eventos</h5>
                <span class="p-input-icon-left mt-2 md:mt-0">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Pesquisar..." />
                </span>
            </div>

        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 15%">ID</th>
                <th style="width: 55%">Descrição Evento</th>
                <th class="col-acoes" style="width: 30%; min-width: 120px">Ações</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-dt>
            <tr>
                <td><span class="p-column-title negrito">ID: </span>{{dt.id}}</td>
                <td><span class="p-column-title negrito">Descrição Evento: </span>{{dt.descricao_evento}}</td>
                <td class="col-acoes" style="text-align: center; white-space: nowrap">
                    <span class="p-column-title negrito">Ações: </span>
                    <button pButton pRipple
                        icon="pi pi-pencil" class="p-button-rounded p-button-primary mr-2"
                        pTooltip="Editar" (click)="edit(dt)"></button>
                    <button pButton pRipple [disabled]="!direitoExcluir"
                        icon="pi pi-trash" class="p-button-rounded p-button-danger"
                        pTooltip="Excluir evento" (click)="confirmarExclusao(dt)"></button>
                </td>
            </tr>
        </ng-template>

        </p-table>
    </div>
</div>


<p-dialog header="Cadastro de Eventos" [(visible)]="displayModal" [modal]="true" [breakpoints]="{'960px': '75vw'}"
    [style]="{width: '50vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div [ngStyle]="{'margin': '7px'}">
        <form [formGroup]="form" class="p-fluid grid">

            <div class="field field-label-top col-12 md:col-12 xl:col-12">
                <label for="descricao_evento">Descrição Evento</label>
                <input type="text" id="descricao_evento" pInputText formControlName="descricao_evento">
            </div>
            <div class="field field-label-top col-12 md:col-12 xl:col-12">
                <label for="tipo_variavel_coleta">Tipo Variável Coleta (Opcional)</label>
                <p-dropdown inputId="tipo_variavel_coleta" formControlName="tipo_variavel_coleta"
                    [options]="dropDownTipoVariavel"
                    optionLabel="label"
                    optionValue="value"
                    [showClear]="true"
                    placeholder="Selecione o Tipo de Variável de Coleta">
                </p-dropdown>
            </div>
            <div class="field col-12 md:col-12 xl:col-12">
                <p-checkbox label="Gerar Consolidação Diária" [binary]="true" formControlName="gerar_cosolidacao_diaria"></p-checkbox>
            </div>
            <div class="field field-label-top col-12 md:col-12 xl:col-12">
                <label for="valor_padrao">Valor Padrão</label>
                <p-inputNumber inputId="valor_padrao" formControlName="valor_padrao"
                    [min]="0"
                    [maxFractionDigits]="2"
                    mode="decimal"
                    placeholder="0.00"
                    styleClass="w-full">
                </p-inputNumber>
            </div>
        </form>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" icon="pi pi-arrow-left" (click)="displayModal = false" label="Voltar"
            class="p-button-raised p-button-warning mr-2">
        </button>
        <button *ngIf="loading == false" pButton pRipple type="button" icon="pi pi-check" (click)="save()"
            label="Salvar" class="p-button-raised p-button-success"></button>
        <p-progressSpinner *ngIf="loading" [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner"
            strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
    </ng-template>
</p-dialog>

